import { v4 as uuidv4 } from "uuid";
export class ProjectTaskComboModel {
    constructor() {
        this.projectId = uuidv4();
        this.projectCode = "";
        this.projectName = "";
        this.projectDescription = "";
        this.taskId = uuidv4();
        this.taskCode = "";
        this.taskName = "";
        this.taskDescription = "";
    }
}
export default class ProjectTaskCombo extends ProjectTaskComboModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
